var AppStore = require('./../../store/appStore');
var ErrorLayout = require('./../../helper/layout-helper').errorLayout;

var ErrorChecker = {

  componentWillMount(){
    AppStore.addErrorListener(this._onError);
  },

  componentWillUnmount(){
    AppStore.removeErrorListener(this._onError);
  },

  componentWillReceiveProps(nextProps){
  	if (nextProps.location.key !== this.props.location.key) {
			this.setState({
				error: null
			});
		}
  },

  getInitialState(){
    return {
      error: AppStore.getAppError()
    };
  },

  _onError(){
    this.setState({
      error: AppStore.getAppError()
    });
  },

  _getPageContent(content){
    if (this.state.error) {
      return <ErrorLayout error={this.state.error}/>
    }

    return content;
  }

};


module.exports = ErrorChecker;
